/**
 * Standard primary palette scale (match `variants/dathacons` + MUI).
 * Site builder / DB can store the same object under `layout.theme` → `mui.palette.primary`.
 */
export type MuiPrimaryColorScale = {
  50: string;
  100: string;
  200: string;
  300: string;
  400: string;
  500: string;
  600: string;
  700: string;
  800: string;
  900: string;
  main: string;
  contrastText: string;
};

/** MUI `palette.primary` with `light` = shade [100] (Bazaar / Salify pattern). */
export function muiPrimaryFromScale(
  scale: MuiPrimaryColorScale & { [k: string]: string | number | undefined },
) {
  return { ...scale, light: String(scale[100]) };
}
